import { ChangeDetectionStrategy, Component, Input } from "@angular/core";

import { IBlog } from "./../blog.interface";

@Component({
    selector: "mlp-card",
    templateUrl: "./card.component.html",
    styleUrls: ["./card.component.scss"],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CardComponent {
    @Input() blog: IBlog;
    @Input() cardStyle: "lightFont";
    @Input() link: Array<string>;
    @Input() showDescription: boolean;
}
